import React from 'react'
import PropTypes from 'prop-types'
import { connect, getIn, Field } from 'formik'

import Fieldset from '../Fieldset/Fieldset'
import ErrorMessage from '../../Form/ErrorMessage/ErrorMessage'

import './SpecialInstructions.css'

const SpecialInstructionsComponent = ({
  label,
  maxLength,
  name,
  formik,
  placeholder,
  rows
}) => {
  const current = getIn(formik.values, name).length
  const msg = `${current} / ${maxLength}`
  const instructions = (
    <React.Fragment>
      <span data-testid='modifier-special-instructions-max-length'>{maxLength} characters or less</span>
      {current ? <span data-testid='modifier-special-instructions-count'>{msg}</span> : null}
    </React.Fragment>
  )
  return (
    <Fieldset
      label={label}
      instructions={instructions}
      name={name}
    >
      <Field
        styleName='specialInstructions'
        maxLength={maxLength}
        rows={rows}
        name={name}
        component='textarea'
        placeholder={placeholder}
      />
      <ErrorMessage name={name} />
    </Fieldset>
  )
}

SpecialInstructionsComponent.propTypes = {
  label: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  name: PropTypes.string,
  formik: PropTypes.object.isRequired,
  placeholder: PropTypes.string,
  rows: PropTypes.number.isRequired
}

export const SpecialInstructions = connect(SpecialInstructionsComponent)
